module.exports = __webpack_public_path__ + "static/img/logo.bea90b1c.svg";